"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDatabaseClusterEvictionPolicy = void 0;
const getDatabaseClusterEvictionPolicy = ({ httpClient, }) => ({ database_cluster_id, }) => {
    const path = '/databases';
    const url = `${path}/${database_cluster_id}/eviction_policy`;
    return httpClient.get(url);
};
exports.getDatabaseClusterEvictionPolicy = getDatabaseClusterEvictionPolicy;
//# sourceMappingURL=get-database-cluster-eviction-policy.js.map